import React from 'react'

type TransactionDetails = {
  firstName?: string
  lastName?: string
  street1?: string
  street2?: string
  city?: string
  region?: string
  postalCode?: string
  nationality?: string
  dateOfBirth?: string
}

type Props = {
  transactionDetails?: TransactionDetails
}

const KycConfirmation: React.FC<Props> = ({transactionDetails}) => {
  if (!transactionDetails) return null

  const fullName = `${transactionDetails.firstName || ''} ${transactionDetails.lastName || ''}`.trim()
  const addressLine1 = [transactionDetails.street1, transactionDetails.street2].filter(Boolean).join(' ')
  const addressLine2 = [transactionDetails.postalCode, transactionDetails.city, transactionDetails.region].filter(Boolean).join(' ')

  return (
      <div className="bg-gray-100 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-lg p-3 space-y-2 text-sm">
        <p className="text-xs text-gray-600 dark:text-gray-400 leading-snug">
          Please ensure your KYC data matches your bank account details. Mismatches may prevent successful transfers. If any information is incorrect, please
          contact support before proceeding.</p>

        <div className="text-gray-900 dark:text-white space-y-0.5">
          <div className="font-medium">
            {fullName}
            {transactionDetails.dateOfBirth && (
                <span className="text-xs text-gray-500 dark:text-gray-400"> (Date of birth: {transactionDetails.dateOfBirth})</span>
            )}
          </div>

          {addressLine1 && <div>{addressLine1}</div>}
          {addressLine2 &&
              <div className="flex align-items">{addressLine2}
                {transactionDetails.nationality && <div className="pl-1 pt-0.5 text-xs text-gray-500 dark:text-gray-400 ">({transactionDetails.nationality})</div>}
              </div>}

        </div>
      </div>
  )
}

export default KycConfirmation
